// import { useState, useEffect } from "react";
// import { getClosedSiteFinancials } from "../services/analyticsService";

// /**
//  * Closed Site Financials (Report 2.0) — KPIs and rows from GET /analytics/closed-site-financials.
//  * @param {string|number|null|undefined} tenantId
//  * @param {number|null|undefined} year
//  * @param {number|null|undefined} month 1–12
//  */
// export const useClosedSiteFinancialsReport = (tenantId, year, month) => {
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     if (!tenantId || year == null || month == null) {
//       setData(null);
//       setError(null);
//       setLoading(false);
//       return undefined;
//     }

//     let cancelled = false;
//     setLoading(true);
//     setError(null);

//     (async () => {
//       try {
//         const response = await getClosedSiteFinancials(tenantId, year, month);
//         if (cancelled) return;
//         if (response?.success && response?.data != null) {
//           setData(response.data);
//         } else {
//           setData(null);
//           setError(new Error(response?.message || "Failed to load closed site financials"));
//         }
//       } catch (err) {
//         if (cancelled) return;
//         setData(null);
//         setError(err);
//       } finally {
//         if (!cancelled) setLoading(false);
//       }
//     })();

//     return () => {
//       cancelled = true;
//     };
//   }, [tenantId, year, month]);

//   const refresh = async () => {
//     if (!tenantId || year == null || month == null) return;
//     setLoading(true);
//     setError(null);
//     try {
//       const response = await getClosedSiteFinancials(tenantId, year, month);
//       if (response?.success && response?.data != null) {
//         setData(response.data);
//       } else {
//         setData(null);
//         setError(new Error(response?.message || "Failed to load closed site financials"));
//       }
//     } catch (err) {
//       setData(null);
//       setError(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return { data, loading, error, refresh };
// };




import { useState, useEffect } from "react";
import { getClosedSiteFinancials } from "../services/analyticsService";

export const useClosedSiteFinancialsReport = (tenantId, year, month) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!tenantId) {
      setData(null);
      setError(null);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    (async () => {
      try {
        const response = await getClosedSiteFinancials(tenantId, year, month);

        if (cancelled) return;

        if (response?.success && response?.data != null) {
          setData(response.data);
        } else {
          setData(null);
          setError(new Error(response?.message || "Failed to load closed site financials"));
        }
      } catch (err) {
        if (cancelled) return;
        setData(null);
        setError(err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [tenantId, year, month]);

  const refresh = async () => {
    if (!tenantId) return;

    setLoading(true);
    setError(null);

    try {
      const response = await getClosedSiteFinancials(tenantId, year, month);

      if (response?.success && response?.data != null) {
        setData(response.data);
      } else {
        setData(null);
        setError(new Error(response?.message || "Failed to load closed site financials"));
      }
    } catch (err) {
      setData(null);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, refresh };
};